<div mat-dialog-container>
  <div mat-dialog-title style="display: flex; flex-direction: row;">
    <div class="dialog-header">Kopiervorlage für E-Mail-Template</div>
  </div>

  <mat-dialog-content>
    <mat-form-field>
      <mat-label>BCC Empfänger</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
                #inputTargetBccAddresses>{{data.bccAddresses}}</textarea>
      <button matSuffix mat-icon-button
              aria-label="Empfängeradressen kopieren"
              data-qa="copy-bccaddresses"
              (click)="copyToClipBoard(inputTargetBccAddresses)"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
    </mat-form-field>
  </mat-dialog-content>

  <div mat-dialog-actions align="end">
    <button matButton="filled"
            color="primary"
            mat-dialog-close
    >
      <mat-icon svgIcon="innogy_picto_close"></mat-icon>
      Schließen
    </button>
  </div>
</div>
